import sliceCreator from '../../index.jsx';
import {GET_BY_ID_VARIETY} from '../../../constants/index.jsx';
const _getByVarietyAction = sliceCreator('GET_BY_ID_VARIETY', GET_BY_ID_VARIETY, 'get');

const { asyncAction: getByVarietyAction, reducer, clearData: clearGetByVarietyAction } = _getByVarietyAction;

export default reducer;

export {
    getByVarietyAction,
    clearGetByVarietyAction
}